module.exports = __webpack_public_path__ + "static/l2_large-0405d0f53dc20c30d102b38075166efc.jpg";